module.exports = __webpack_public_path__ + "static/img/guidance7.1afc277d.webp";